import React, { useEffect, useState } from "react";
import "../HomeWork.css";
import AllQuestions from "./QuestionTypes/AllQuestions";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "../../../axios";
import FilterNotFound from "../Filter_Box/FilterNotFound";
import { SubjectIcon } from "../../../SubjectIcon";
import { useNavigate, useNavigation } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

export default function Pending({ filter }) {
  const [pending, setPending] = useState({
    question: false,
    homeworkId: null,
  });

  const navigate = useNavigate()
  const [pendingCard, setPendingCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [todaysData, setTodaysData] = useState([]);
  const [noContentClick, setNoContentClick] = useState(false);
  const [previousData, setPreviousData] = useState([]);
  const today = moment().format("YYYY-MM-DD");

  const getPendingHW = async () => {
    try {
      let response = await axios.get(
        `/homework/filterByStudentId/${currentUser?.id}/pending?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
        `${filter?.date
          ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
          : ``
        }` +
        `${filter?.time ? `&time=${filter?.time}` : ``}` +
        `${filter?.subjectId?.length !== 0
          ? `&subjectId=${filter?.subjectId}`
          : ``
        }`
      );

      response &&
        setTodaysData(
          response.data.data.filter(
            (item) => item.deadline.substring(0, 10) === today
          )
        );
      setPreviousData(
        response.data.data.filter(
          (item) => item.deadline.substring(0, 10) !== today
        )
      );
      setPendingCard(response.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPendingHW();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleQuestionfalse = () => {
    setPending({
      ...pending,
      question: false,
    });
  };

  console.log(moment.utc(previousData[0]?.deadline).local().isBefore(new Date), new Date())



  return (
    <div>
      {pendingCard && pendingCard.length > 0 ? (
        <div>
          <div className="headingOfHW mt-3">Today ({todaysData.length})</div>
          <div className="horizontalLine"></div>

          <div
            className="d-flex gap-4 mt-3 flex-wrap"

          >
            {todaysData &&
              todaysData.length > 0 &&
              todaysData.map((item, index) => (
                // <div>
                //   <div style={{ height: "12px", backgroundColor: "red" }}></div>
                //   <div
                //     className="containerForPendinDeatail p-3 "
                //     onClick={(e) => {
                //       setPending({
                //         ...pending,
                //         question: true,
                //         homeworkId: item?.id,
                //       });
                //     }}
                //     key={index}
                //   >
                //     <div className="kannadaHeader">
                //       {item?.subject_id?.name}
                //     </div>
                //     <div className="headingOfHW mt-2">{item?.name}</div>
                //     <span className="deadline">Deadline</span> &nbsp;
                //     <span className="deadlineDate">
                //       {timeHelper(item?.deadline)}
                //     </span>
                //   </div>
                // </div>
                <div
                  key={index}
                  // className="summarySubBoxContainerHW"
                  className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                  style={{
                    borderTop: `8px solid #${item?.subject_id?.subject_color}`,
                  }}
                  onClick={(e) => {
                    setPending({
                      ...pending,
                      question: true,
                      homeworkId: item?.id,
                    });
                    navigate(`/publishedHomework`, { state: { homeworkId: item?.id } });
                  }}
                >
                  <div
                    className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                  >
                    <div>
                      <div className="subboxSubjectName">
                        {item?.subject_id?.name}
                      </div>
                    </div>
                    <div>
                      <img
                        src={`${SubjectIcon?.find(
                          (i) => i.subjectName === item?.subject_id?.name
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="SubsummarySubBoxContainer"
                    style={{ paddingTop: "0" }}
                  >
                    <div className="headingOfHW" title={item?.name}>
                      <Tooltip
                        title={item?.name}
                        arrow
                        placement="top"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <span className="flex sbj">
                          <BookText size={16} className="me-2 mt-1 text-dark" />
                          {shortenParagraph(item?.name, 25)}
                        </span>
                      </Tooltip>
                    </div>
                    <div className="flex mt-2">
                      <CalendarDays size={16} className="me-2 text-dark" />
                      <span className="deadline">Deadline: </span> &nbsp;
                      <span className="deadlineDate">
                        {timeHelper(item?.deadline)}
                      </span>
                    </div>
                    <span
                      style={{
                        color: "#FF0000",
                        fontSize: "16px",
                        fontWeight: "600",
                        textAlign: "right",
                        display: "block",
                      }}
                    >
                      {/* Compares only the date, not the time. */}
                      {moment.utc(item?.deadline).local().startOf('day').isBefore(moment().startOf('day'))
                        ? "Delayed"
                        : " "}
                    </span>
                  </div>
                </div>
              ))}
          </div>

          <div className="headingOfHW mt-3">Others ({previousData.length})</div>
          <div className="horizontalLine"></div>
          <div
            className="d-flex gap-4 mt-3 flex-wrap"

          >
            {previousData &&
              previousData.length > 0 &&
              previousData.map((item, index) => (
                // <div>
                //   <div style={{ height: "12px", backgroundColor: "red" }}></div>
                //   <div
                //     key={index}
                //     onClick={(e) => {
                //       setPending({
                //         ...pending,
                //         question: true,
                //         homeworkId: item?.id,
                //       });
                //     }}
                //     className="containerForPendinDeatail p-3 "
                //   >
                //     <div className="kannadaHeader">
                //       {item?.subject_id?.name}
                //     </div>
                //     <div className="headingOfHW mt-2">{item?.name}</div>
                //     <span className="deadline">Deadline</span> &nbsp;
                //     <span className="deadlineDate">
                //       {timeHelper(item?.deadline)}
                //     </span>
                //   </div>
                // </div>
                <div
                  key={index}
                  // className="summarySubBoxContainerHW"
                  className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                  style={{
                    borderTop: `8px solid #${item?.subject_id?.subject_color}`,
                  }}
                  onClick={(e) => {
                    setPending({
                      ...pending,
                      question: true,
                      homeworkId: item?.id,
                    });
                    navigate(`/publishedHomework`, { state: { homeworkId: item?.id } });
                  }}
                >
                  <div
                    className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                  >
                    <div>
                      <div className="subboxSubjectName">
                        {item?.subject_id?.name}
                      </div>
                    </div>
                    <div>
                      <img
                        src={`${SubjectIcon?.find(
                          (i) => i.subjectName === item?.subject_id?.name
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="SubsummarySubBoxContainer"
                    style={{ paddingTop: "0" }}
                  >
                    <div className="headingOfHW" title={item?.name}>

                      <Tooltip
                        title={item?.name}
                        arrow
                        placement="top"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <span className="sbj flex">
                          <BookText size={16} className="me-2 mt-1 text-dark" />
                          {shortenParagraph(item?.name, 25)}
                        </span>
                      </Tooltip>
                    </div>
                    <div className="flex mt-1">
                      <CalendarDays size={16} className="me-2 text-dark" />
                      <span className="deadline">Deadline: </span> &nbsp;
                      <span className="deadlineDate">
                        {timeHelper(item?.deadline)}
                      </span>
                    </div>
                    <span
                      style={{
                        color: "#FF0000",
                        fontSize: "16px",
                        fontWeight: "600",
                        textAlign: "right",
                        display: "block",
                      }}
                    >
                      {/* Compares only the date, not the time. */}
                      {moment.utc(item?.deadline).local().startOf('day').isBefore(moment().startOf('day'))
                        ? "Delayed"
                        : " "}
                    </span>
                  </div>
                </div>
              ))}
          </div>

          {/* {pending.question && (
            <AllQuestions
              handleQuestionfalse={handleQuestionfalse}
              homeworkId={pending?.homeworkId}
            />
          )} */}
        </div>
      ) : isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <span>Homework Not Found</span>
        // : noContentClick ? (
        //   <span>Homework Not Found</span>
        // ) : (
        //   <FilterNotFound setNoContentClick={setNoContentClick} />
      )}
    </div>
  );
}
